<template>
    <ScrollStrip
        ref="strip"
        label="Choose a day"
        prev-label="Show earlier days"
        next-label="Show later days"
    >
        <button
            v-for="entry in days"
            :key="entry.key"
            :ref="(element) => setChip(entry.key, element)"
            type="button"
            class="snap-start shrink-0 w-[4.25rem] rounded-xl border px-1 py-2.5 text-center transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700"
            :class="
                entry.selected
                    ? 'bg-primary border-primary text-white'
                    : 'bg-white border-gray-400 hover:border-primary-600'
            "
            :aria-pressed="entry.selected"
            :aria-label="entry.aria"
            @click="$emit('select', entry.day)"
        >
            <span
                class="block text-xs font-semibold uppercase tracking-wider"
                :class="entry.selected ? 'text-white' : 'text-gray-600'"
            >
                {{ entry.weekday }}
            </span>
            <span
                class="block text-xl font-bold leading-tight"
                :class="entry.selected ? 'text-white' : entry.closed ? 'text-gray-500' : 'text-gray-900'"
            >
                {{ entry.dayOfMonth }}
            </span>
            <span
                class="block text-xs font-semibold"
                :class="entry.selected ? 'text-white' : 'text-gray-600'"
            >
                {{ entry.note }}
            </span>
        </button>
    </ScrollStrip>
</template>

<script setup>
    import { nextTick, onMounted, ref, watch } from "vue";
    import ScrollStrip from "./ScrollStrip.vue";

    const props = defineProps({
        /** Descriptors built by MobileCalendar so this stays a dumb strip. */
        days: Array,
    });

    defineEmits(["select"]);

    const strip = ref(null);
    const chips = new Map();

    const setChip = (key, element) => (element ? chips.set(key, element) : chips.delete(key));

    // "Jump to the next open day" can land off-screen, so follow the selection along.
    const revealSelected = async () => {
        await nextTick();

        strip.value?.reveal(chips.get(props.days.find((day) => day.selected)?.key));
    };

    onMounted(revealSelected);

    watch(() => props.days.find((day) => day.selected)?.key, revealSelected);
</script>
